// @flow

import React from 'react';
import {ButtonLink} from 'sail/Button';
import Group from 'sail/Group';
import {BodyAlt} from 'sail/Text';
import Icon from 'sail/Icon';
import {useAccount} from 'docs/data';
import {getLoginUrl} from 'docs/util';
import {FormattedMessage} from 'react-intl';
import {headerMessages} from './Header.messages';

export const DashboardLink = () => {
  const {account} = useAccount();

  if (!account.user) {
    return null;
  }

  return (
    <Group direction="horizontal" spacing={8} alignItems="center">
      <BodyAlt>
        <ButtonLink
          color="gray700"
          label={<FormattedMessage {...headerMessages.dashboard} />}
          href={getLoginUrl({account})}
        />
      </BodyAlt>
      <Icon size={12} icon="arrowRight" />
    </Group>
  );
};
